// Retail module uses the shared commonRoutes.
// DynamicDashboard inside commonRoutes adapts automatically for retail store_type.
import { commonRoutes } from '../../routes/commonRoutes';
export const retailRoutes = commonRoutes;
